/* Estilos Cart  Custom*/

function $reindexacionRebuy(){
  $('#rebuy-cart .rebuy-cart__flyout').prepend('<div class="rebuy-new-cart"><div class="container-rebuy-cart-new"></div></div>');
  $( "#rebuy-cart .rebuy-new-cart .container-rebuy-cart-new" ).append($( ".rebuy-cart__flyout-header, .rebuy-cart__flyout-body, .rebuy-cart__flyout-footer" ));
  $('#rebuy-cart .rebuy-new-cart').append('<div data-rebuy-id="163192"></div>');
  $('#rebuy-cart .rebuy-cart__flyout-content').prepend('<div class="container-progress-bar-move"></div>');
  $( "#rebuy-cart .rebuy-cart__flyout-content .container-progress-bar-move" ).prepend($( "#rebuy-cart .rebuy-cart__flyout-body .rebuy-cart__progress-bar-container" ));

  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').before(
    '<div id="stars-rebuy-show">' + 
      '<div class="stars">' + 
        '<svg version="1.1" id="stars-reviews-rebuy-cart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 67 11.2" style="enable-background:new 0 0 67 11.2;" xml:space="preserve">' +
          '<g>' +
            '<polygon points="7.4,4.1 5.9,0 4.4,4.1 0,4.3 3.4,7 2.2,11.2 5.9,8.8 9.5,11.2 8.3,7 11.8,4.3"/>' +
          	'<polygon points="21.2,4.1 19.7,0 18.2,4.1 13.8,4.3 17.2,7 16,11.2 19.7,8.8 23.3,11.2 22.2,7 25.6,4.3"/>' +
          	'<polygon points="29.8,11.2 33.5,8.8 37.2,11.2 36,7 39.4,4.3 35,4.1 33.5,0 32,4.1 27.6,4.3 31,7"/>' +
          	'<polygon points="48.8,4.1 47.3,0 45.8,4.1 41.4,4.3 44.8,7 43.7,11.2 47.3,8.8 51,11.2 49.8,7 53.2,4.3"/>' +
          	'<polygon points="67,4.3 62.6,4.1 61.1,0 59.6,4.1 55.2,4.3 58.7,7 57.5,11.2 61.1,8.8 64.8,11.2 63.6,7"/>' +
          '</g>' +
        '</svg>' +
      '</div>' + 
      '<div class="message">' + 
        '<p><em>Thousands of Satisfied Customers</em></p>' + 
      '</div>' + 
    '</div>'
  );

};

function ajustarAltura() {
  var alturaVisible = window.innerHeight + "px";
  document.querySelector('.container-rebuy-cart-new').style.height = alturaVisible;
  console.log(alturaVisible);
};

window.addEventListener("resize", ajustarAltura);



document.addEventListener('rebuy:smartcart.ready', function(event){
  // console.log('rebuy:smartcart.ready event', event.detail);
  let $qty = event.detail.smartcart.cart.item_count;

  if($qty > 0){
    $('.menu__item.menu__item--icon a.cart__toggle').addClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle').addClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle .cart-indicator').css('visibility','visible');
  } else {
    $('.menu__item.menu__item--icon a.cart__toggle').removeClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle').removeClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle .cart-indicator').css('visibility','hidden');
  };

  $('#rebuy-cart .rebuy-cart__flyout-content').on('scroll', function() {
    if ($(this).scrollTop() > 0) {
      $('#rebuy-cart .rebuy-cart__flyout-header').addClass('scroll-move-header');
    } else {
      $('#rebuy-cart .rebuy-cart__flyout-header').removeClass('scroll-move-header');
    }
  });

  $reindexacionRebuy();
  ajustarAltura();

});

document.addEventListener('rebuy:cart.change', function(event){
  // console.log('rebuy:cart.change event', event.detail);
  let $qty = event.detail.cart.cart.item_count;
  if($qty > 0){
    $('.menu__item.menu__item--icon a.cart__toggle').addClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle').addClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle .cart-indicator').css('visibility','visible');
  } else {
    $('.menu__item.menu__item--icon a.cart__toggle').removeClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle').removeClass('cart__toggle--has-items');
    $('.menu__item.menu__item--compress a.cart__toggle .cart-indicator').css('visibility','hidden');
  };
});
